import { React, useContext, useEffect } from "react";
import { Modal, Heading, Button, Flex, StatusIcon, Text } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";
import "./warning-confirmation-alert.scss";

function WarningConfirmationAlert(props) {
  const { showWarningConfirmation, cancelDelete, confirmDelete } = props;
  const i18n = useContext(I18nContext);
  const styles = {
    mdsRebuildModalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      overflow: "auto",
      display: "grid",
      alignItems: "center",
      justifyItems: "center",
      placeItems: "center",
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.4)",
      zIndex: 200
    }
  };

  useEffect(() => {
    console.log("WarningConfirmationAlert Mount");

    return () => {
      console.log("WarningConfirmationAlert Destroy");
    };
  }, []);

  return (
    <Flex>
      <Modal size="md" style={styles.mdsRebuildModalOverlay} isOpen={showWarningConfirmation}>
        <Flex direction="vertical">
          <Flex
            align="center"
            gap={12}
            margin={{
              bottom: 25
            }}
            style={{ "margin-bottom": "25px" }}
          >
            <StatusIcon
              status="warning"
              style={{
                marginTop: -2
              }}
            />
            <Heading as="h2" size="primary">
              {i18n.t("business-location-details.confirmation-text")}
            </Heading>
          </Flex>
          <Flex align="flex-start" direction="vertical" gap={8}>
            <Text align="left" size="p3">
              {i18n.t("add-edit-controller.are-you-sure-text")}
            </Text>
            <Text align="left" color="light" size="p4">
              {i18n.t("add-edit-controller.delete-consent-text")}
            </Text>
          </Flex>
          <Flex justify="flex-end">
            <Button.Group
              style={{
                paddingTop: 25
              }}
            >
              <Button kind="secondary" size="sm" onClick={cancelDelete}>
                {i18n.t("business-location-details.cancel-text")}
              </Button>
              <Button destructive size="sm" onClick={confirmDelete}>
                {i18n.t("business-location-details.delete-text")}
              </Button>
            </Button.Group>
          </Flex>
        </Flex>
      </Modal>
    </Flex>
  );
}

export default WarningConfirmationAlert;
